import formatFileSize from './utils'

const messages = {
  _default: () => `vrednost ni veljavna`,
  after: (field, [target, , inclusion]) =>
    `mora biti po ${inclusion ? 'ali enako' : ''}${target}.`,
  alpha_dash: () =>
    `polje lahko vsebuje alfanumerične znake ter črtice in podčrtaje.`,
  alpha_num: () =>
    `polje lahko vsebuje samo alfa-številčne znake.`,
  alpha: () =>
    `polje lahko vsebuje samo abecedne znake.`,
  alpha_spaces: () =>
    `polje lahko vsebuje samo abecedne znake in presledke.`,
  before: (field, [target, inclusion]) =>
    `mora biti pred ${inclusion ? 'ali enako' : ''}${target}.`,
  between: (field, [min, max]) =>
    `polje mora biti med ${min} in ${max}.`,
  confirmed: () =>
    `potrditev se ne ujema.`,
  credit_card: () =>
    ` polje ni veljavno.`,
  date_between: (field, [min, max]) =>
    `mora biti med ${min} in ${max}.`,
  date_format: (field, [format]) =>
    `mora biti v obliki ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `polje mora biti numerično in lahko vsebuje  ${!decimals || decimals === '*' ? '' : decimals} decimalnih točk.`,
  digits: (field, [length]) =>
    `polje mora biti numerično in vsebovati natančno ${length} števk.`,
  dimensions: (field, [width, height]) =>
    `polje mora biti ${width} slikovnih pik krat ${height} slikovnih pik.`,
  email: () =>
    `polje mora biti veljaven email naslov.`,
  ext: () =>
    `polje mora biti veljavna datoteka.`,
  image: () =>
    `polje mora biti slika.`,
  in: () =>
    `polje mora biti veljavna vrednost.`,
  integer: () =>
    `polje mora biti celo število.`,
  ip: () =>
    `polje mora biti veljaven IP naslov.`,
  length: (field, [length, max]) => {
    if (max) {
      return `dolžina mora biti med ${length} in ${max}.`
    }

    return  `dolžina mora biti ${length}.`
  },
  max: (field, [length]) =>
    `polje ne sme biti daljše od ${length} znakov.`,
  max_value: (field, [max]) =>
    `polje mora biti ${max} ali manjše.`,
  mimes: () =>
    `polje mora imeti veljavno vrsto datoteke.`,
  min: (field, [length]) =>
    `polje mora imeti vsaj ${length} znakov.`,
  min_value: (field, [min]) =>
    `polje mora biti ${min} ali večje.`,
  not_in: () =>
    `polje mora biti veljavna vrednost.`,
  numeric: () =>
    `polje lahko vsebuje le številčne znake.`,
  regex: () =>
    `oblika polja ni veljavna.`,
  required: () =>
    `polje je obvezno.`,
  size: (field, [size]) => `velikost mora biti manjša od ${formatFileSize(size)}.`,
  url: () => `polje ni veljaven URL.`,
  fullName: () => `ni veljavno (ime, ime in največ 120 znakov)`,
  emailInput: () => 'polje mora biti veljaven email naslov.',
  fullNamePerCountry: () => 'ni veljavno (ime, ime in največ 18 znakov)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'sl',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/sl.js